import type { HelpCenterArticleProposal } from "@productlane/zero"

import type { VersionAuthorUser } from "@/components/version-author"

export type ClosedProposalStatus = "ACCEPTED" | "REJECTED" | "SUPERSEDED"

export type ClosedProposal = HelpCenterArticleProposal & {
	baseVersion?: { content?: unknown } | null
	createdBy?: VersionAuthorUser | null
	closedBy?: VersionAuthorUser | null
	group?: { title?: string | null; description?: string | null } | null
}

/** Outcome wording and badge tone for a reviewed suggestion. */
export function outcomeLabel(status: string): {
	label: string
	variant: "green" | "red" | "default"
} {
	if (status === "ACCEPTED") return { label: "Accepted", variant: "green" }
	if (status === "REJECTED") return { label: "Rejected", variant: "red" }
	return { label: "Superseded", variant: "default" }
}

/** The base article HTML a proposal was drafted against, when still on record. */
export function baseHtmlOf(proposal: ClosedProposal): string {
	const content = proposal.baseVersion?.content
	return typeof content === "string" ? content : ""
}

/** The proposal's steps as an array, since Zero types the JSON column as nullable. */
export function stepsOf(proposal: ClosedProposal): unknown[] {
	const steps = proposal.proposedSteps
	return Array.isArray(steps) ? steps : []
}

/** Newest decision first, with undated rows falling back to creation time. */
export function sortByClosedAt(
	proposals: readonly ClosedProposal[],
): ClosedProposal[] {
	return [...proposals].sort(
		(a, b) => (b.closedAt ?? b.createdAt) - (a.closedAt ?? a.createdAt),
	)
}
